import React, { useState, useEffect, useRef } from 'react';
import siteLogo from '../../assets/images/logo_new.png';
import siteLogoBlack from '../../assets/images/logo_white.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AppThemePopup from '../../modules/default/popup/appTheme/appThemePopup';
import { useDispatch, useSelector } from 'react-redux';
import { loginOutAction } from '../../store/actions/authActions';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import { notificationAction, notificationStatusArchiveAction, notificationStatusUpdateAction } from '../../store/actions/new/notificationAction';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import ShimmerImage from '../../modules/default/popup/shimmerImage/shimmerImage';
import { PrismTimeFormatter } from '../../modules/default/utils/timeFormatter';
import { InitialAvatar } from '../../modules/default/utils/defaultAvatar';
const Header = ({ settingsMenu }) => {

    const [activeMenu, setActiveMenu] = useState(null);
    const notificationRef = useRef(null);
    const profileRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const toggleMenu = (menu) => {
        setActiveMenu(prevMenu => (prevMenu === menu ? null : menu));
    };
    const location = useLocation();
    const isActive = (path) => {
        return location.pathname === path || (location.pathname.startsWith(path) && path !== '/') ? 'active-menu' : '';
    };
    const handleClickOutside = (event) => {
        if (
            (notificationRef.current && !notificationRef.current.contains(event.target)) &&
            (profileRef.current && !profileRef.current.contains(event.target))
        ) {
            setActiveMenu(null);
        }
    };
    // all notification click to hide dropdown
    const handleToggleDropdown = () => {
        setActiveMenu(null);
    }
    //handle logout
    const MySwal = withReactContent(Swal)
    const handleLogOut = () => {
        MySwal.fire({
            title: "You’re about to be logged out. Continue?",
            // text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#787878",
            confirmButtonText: "Yes, Logout",
            customClass: {
                actions: "button-reverse"
            },
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                dispatch(loginOutAction(navigate));
            }
        });
    }
    const { userData, notificationData } = useSelector((store) => store);
    const { notificationAllData } = notificationData;
    const { data, pagination, unread, isLoading } = notificationAllData;

    // single notification open
    const handleNotificationClick = (id, status) => {
        // Dispatch an action to mark single notification as read
        if (status === "new") {
            dispatch(notificationStatusUpdateAction(id));
        }
        navigate(`/notification/${id}?status=${status}`);
    };
    //notification archive
    const [isArchiving, setIsArchiving] = useState(false);
    const handleNotificationArchive = async (id) => {
        setIsArchiving(true); // Set loading state
        await dispatch(notificationStatusArchiveAction(id));
        setIsArchiving(false); // Reset loading state
    };
    const totalUnread = unread ? unread : "";
    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(notificationAction(1, ""));
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //function to show popup
    const [openPopup, setPopup] = useState(false);
    const handlePopup = () => {
        setPopup(true);
        setActiveMenu(null);
    }

    // Set the limit for notifications to display
    const limit = 4;
    const filteredNotifications = data
        ? data.filter(notification => notification).slice(0, limit)
        : [];
    return (
        <header className="header-area">
            <div className="card-container">
                <div className="card-row">
                    <div className="card-col-4">
                        <Link to="/" className="site-logo">
                            <img className='white-logo' src={siteLogo} alt="site logo" />
                            <img className='black-logo' src={siteLogoBlack} alt="site logo" />
                            <i>portal</i>
                        </Link>
                    </div>
                    <div className="card-col-8">
                        <div className="header-right">
                            <div className="notification-wrapper" ref={notificationRef}>
                                <div className="notification-area" onClick={() => toggleMenu('notification')}>
                                    <i className="ri-notification-2-line"></i>
                                    {totalUnread > 0 ? <span className="notification-bubble"></span> : ""}
                                </div>
                                {activeMenu === 'notification' && (
                                    <div className="header-user-menu notification-subMenu">
                                        <div className="ntf-header">
                                            <h4>Notifications</h4>
                                            {totalUnread > 0 ? <Link to="/notification/unread" className="ntf-count">{totalUnread} New</Link> : ""}

                                        </div>
                                        <div className="ntf-wrapper">
                                            {filteredNotifications.length > 0 ? (
                                                filteredNotifications.map((notification) => (
                                                    <div className="ntf-single" key={notification.id}>
                                                        <div className="ntf-lft-content">
                                                            <img src={notification.icon} alt='' />
                                                            <div className="ntf-userInfo" onClick={() => handleNotificationClick(notification.id, notification.status)}>
                                                                <h5>{notification.title}</h5>
                                                                <p>{notification.content}</p>
                                                                {notification.date ? (
                                                                    <span>
                                                                        {PrismTimeFormatter(notification.date)}
                                                                    </span>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <button className="ntf-close-btn" onClick={() => handleNotificationArchive(notification.id)}>
                                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M6.99873 5.5865L11.9485 0.636719L13.3627 2.05093L8.41293 7.0007L13.3627 11.9504L11.9485 13.3646L6.99873 8.4149L2.04899 13.3646L0.634766 11.9504L5.58453 7.0007L0.634766 2.05093L2.04899 0.636719L6.99873 5.5865Z" fill="#717171" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="no-notifications">No new notifications</div>
                                            )}
                                            {isLoading &&
                                                <>
                                                    <ShimmerCategoryItem
                                                        hasImage
                                                        imageType="circular"
                                                        imageWidth={50}
                                                        imageHeight={50}
                                                        text
                                                    />
                                                    <ShimmerCategoryItem
                                                        hasImage
                                                        imageType="circular"
                                                        imageWidth={50}
                                                        imageHeight={50}
                                                        text
                                                    />
                                                </>
                                            }
                                        </div>
                                        <div className="view-all-ntf">
                                            <Link to='/notification' onClick={() => { handleToggleDropdown() }}>
                                                View all notifications
                                                {pagination && pagination.data_total > 0 && (
                                                    ` (${pagination.data_total})`
                                                )}
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className={`header-profile-area ${activeMenu === 'profile' ? 'active' : ''}`} ref={profileRef}>
                                <div className="profile-settings" onClick={() => toggleMenu('profile')}>
                                    {userData.data.profilePhoto ? (
                                        <ShimmerImage
                                            src={userData.data.profilePhoto}
                                            alt={userData.data.U_Username}
                                            width={45}
                                        />
                                    ) : (
                                        <InitialAvatar
                                            title={`${userData.data.U_Usernamee}`}
                                            size={45}
                                        />
                                    )}
                                    <span>Hi, {userData.data.U_Username}</span>
                                    <i className="ri-arrow-down-s-line"></i>
                                </div>
                                {activeMenu === 'profile' && (
                                    <div className="header-user-menu">
                                        <ul>
                                            <li>
                                                <a href="javascript:void(0)" onClick={handlePopup}><i className="ri-contrast-2-line"></i> App Theme</a>
                                            </li>
                                            <li>
                                                <Link className={isActive('/user/plans')} to="/user/plans"><i className="ri-shopping-bag-line"></i> My Plan</Link>
                                            </li>
                                            <li>
                                                <Link className={isActive('/user/billings')} to="/user/billings"><i className="ri-bill-line"></i> Billings</Link>
                                            </li>
                                            <li>
                                                <Link className={isActive('/user/manage')} to="/user/manage"><i className="ri-user-settings-line"></i> User Settings</Link>
                                            </li>
                                            <li>
                                                <Link onClick={handleLogOut}><i className="ri-logout-circle-line"></i> Log out</Link>
                                            </li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AppThemePopup openModal={openPopup} setOpen={setPopup} />
        </header>
    );
};

export default Header;
